import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed'
import AOS from 'aos';

import Header from '../../../components/Header';
import Footer from '../../../components/Footer';

import photo1 from '../../../assets/images/windfarms/alegria_1/alegria1.jpg';
import photo2 from '../../../assets/images/windfarms/alegria_1/alegria2.jpg';
import photo3 from '../../../assets/images/windfarms/alegria_1/alegria3.jpg';
import photo4 from '../../../assets/images/windfarms/alegria_1/alegria4.jpg';


import './styles.css';
import './../../../assets/styles/globals.css';

function Windfarm() {
  const windfarm =
    {
      "Project": "Alegria 1",
      "MW": "51,0 MW",
      "State": "Rio Grande do Norte",
      "Location": "Guamaré - RN",
      "Turbines": "31",
      "Technology": "WIND",
      "Year": 2010,
      "Investor": "Multiner",
      "Transmission": "90 Km",
      "Investor_country": "Brazil",
      "Status": "Operating",
      "Supplier": "Vestas",
      "Longitude": -36.3629,
      "Latitude": -5.0944,
      "Images": [
        "images/windfarms/alegria_1/alegria1.jpg",
        "images/windfarms/alegria_1/alegria2.jpg",
        "images/windfarms/alegria_1/alegria3.jpg",
        "images/windfarms/alegria_1/alegria4.jpg"
      ],
      "Video": "https://www.youtube.com/embed/Bcwny7Z8PyQ"
    }
  const images = [
    {
      original: photo1,
      thumbnail: photo1,
    },
    {
      original: photo2,
      thumbnail: photo2,
    },
    {
      original: photo3,
      thumbnail: photo3,
    },
    {
      original: photo4,
      thumbnail: photo4,
    }
  ];
  useEffect(() => {
    AOS.init()
    window.scrollTo({
      top: 0,
      left: 0,
    })
  }, [])
  return (
      <>
        <Header />
        <div className="background-alegria-1">
          <div className="container" data-aos-once="true" data-aos="zoom-in" data-aos-duration="1000">
            <div className="banner-windfarm content-windfarm">
              <h1>{windfarm.Project}</h1>
              <p>{windfarm.State}</p>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="gap-windfarm" data-aos-once="true" data-aos="fade-in" data-aos-duration="1000">
            <Row>
              <Col xs={12} md={12} sm={12} lg={8}>
                 <div style={{ height: 'auto' }}>
                    <ResponsiveEmbed aspectRatio="16by9">
                      <iframe title="Windfarm's Video" src='https://www.youtube.com/embed/Bcwny7Z8PyQ' frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" ></iframe>
                    </ResponsiveEmbed>
                  </div>
                  <Row>
                  <div className="windfarm-basic-info">
                    <p>
                      Alegria wind farm (151.8 MW) is the largest wind project under the PROINFA program in Brazil. 
                      The wind farm is located in a 10km sandy coastal area in the state of Rio Grande do Norte. 
                      The wind farm is able to produce electricity for a population of 1 million people.
                    </p>
                  </div>
                </Row>
              </Col>
              <Col xs={12} md={12} sm={12} lg={4}>
                <div className="windfarm-photos" data-aos-once="true" data-aos="fade-in" data-aos-duration="1000">
                  <div>
                    <Row>
                      <ImageGallery items={images}  showNav={false} showPlayButton={false} />
                    </Row>
                  </div>
                </div>
                <table className="windfarm-table">
                  <tbody>
                    <tr>
                      <td>Number of turbines</td>
                      <td>{windfarm.Turbines}</td>
                    </tr>
                    <tr>
                      <td>Total Capacity</td>
                      <td>{windfarm.MW}</td>
                    </tr>
                    <tr>
                      <td>Location</td>
                      <td>{windfarm.Location}</td>
                    </tr>
                    <tr>
                      <td>Transmission Line</td>
                      <td>{windfarm.Transmission}</td>
                    </tr>
                    <tr>
                      <td>Turbine Manufacturer</td>
                      <td>{windfarm.Supplier}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </div>
        </div>
        <Footer />
      </>
  )
}

export default Windfarm;